<template>
  <div class="privacy-form">
    <!-- name -->
    <div class="form-field form-field--text">
      <span
        class="input input--juro"
        :class="{ 'input--filled': name.trim().length > 0 }">
        <input
          v-model="name"
          class="input__field input__field--juro"
          type="text" />

        <label class="input__label input__label--juro" for="input">
          <span class="input__label-content input__label-content--juro">{{ $t('privacyForm.labelName') }}</span>
        </label>
      </span>

      <form-error
        v-if="errors !== undefined && errors.name"
        :errors="errors.name"/>
    </div>

    <!-- surname -->
    <div class="form-field form-field--text">
      <span
        class="input input--juro"
        :class="{ 'input--filled': surname.trim().length > 0 }">
        <input
          v-model="surname"
          class="input__field input__field--juro"
          type="text"/>

        <label class="input__label input__label--juro" for="input">
          <span class="input__label-content input__label-content--juro">{{ $t('privacyForm.labelSurname') }}</span>
        </label>
      </span>

      <form-error
        v-if="errors !== undefined && errors.surname"
        :errors="errors.surname"/>
    </div>

    <!-- email -->
    <div class="form-field form-field--text">
      <span
        class="input input--juro"
        :class="{ 'input--filled': email.trim().length > 0 }">
        <input
          v-model="email"
          class="input__field input__field--juro"
          type="email"/>

        <label class="input__label input__label--juro" for="input">
          <span class="input__label-content input__label-content--juro">Email</span>
        </label>
      </span>

      <form-error
        v-if="errors !== undefined && errors.email"
        :errors="errors.email"/>
    </div>

    <!-- note -->
    <div class="form-field form-field--text">
      <span
        class="input input--juro"
        style="height:200px"
        :class="{ 'input--filled': note.trim().length > 0 }">
        <textarea
          v-model="note"
          class="input__field input__field--juro"
          style="height:200px; min-height:200px; max-height: 200px; min-width:100%; max-width:100%" />

        <label class="input__label input__label--juro" for="input">
          <span class="input__label-content input__label-content--juro">{{ $t('privacyForm.labelNote') }}</span>
        </label>
      </span>

      <form-error
        v-if="errors !== undefined && errors.note"
        :errors="errors.note"/>
    </div>

    <!-- privacy checks -->
    <div class="area-checks">
      <p class="checks">
        <input
          v-model="checkboxes.sendCopy"
          name="check01"
          id="check01"
          value="acconsento"
          type="checkbox">

        <label for="check01" class="label_check">
          <span class="before"></span>
          <span class="text_check">{{ $t('privacyForm.checkSendCopy', { legalName: siteData.legalName }) }}</span>
        </label>
      </p>

      <p v-if="mailchimp" class="checks">
        <input
          v-model="checkboxes.mailChimp"
          name="check02"
          id="check02"
          value="acconsento"
          type="checkbox">

        <label for="check02" class="label_check">
          <span class="before"></span>
          <span class="text_check">{{ $t('privacyForm.checkMailchimp', { legalName: siteData.legalName }) }}</span>
        </label>
      </p>

      <p class="checks">
        <input
          v-model="checkboxes.removeAll"
          name="check03"
          id="check03"
          value="acconsento"
          type="checkbox">
        <label for="check03" class="label_check">
          <span class="before"></span>
          <span class="text_check">{{ $t('privacyForm.checkRemoveAll', { legalName: siteData.legalName }) }}</span>
        </label>
      </p>

      <p v-if="checkboxes.removeMarketing" class="checks">
        <input
          v-model="checkboxes.removeMarketing"
          name="check04"
          id="check04"
          value="acconsento"
          type="checkbox">
        <label for="check04" class="label_check">
          <span class="before"></span>
          <span class="text_check">{{ $t('privacyForm.checkRemoveMarketing', { legalName: siteData.legalName }) }}</span>
        </label>
      </p>
    </div>

    <p class="checks checks-marginUp">
      <input
        v-model="checkboxes.privacy"
        name="check05"
        id="check05"
        value="acconsento"
        type="checkbox">
      <label for="check05" class="label_check">
        <span class="before"></span>
        <!--
        <span class="text_check">
          Acconsento l’utilizzo dei dati attraverso l’invio di questo modulo per le finalità espresse e regolate dalla <router-link :to="{ name: 'privacy', params: { fromSite } }">privacy policy</router-link>.
        </span>
        -->
        <span class="text_check" v-if="fromSite === 'quamm'">{{ $t('privacyForm.checkPrivacyQuamm') }}</span>
        <span class="text_check" v-else>{{ $t('privacyForm.checkPrivacy') }}</span>
      </label>

      <form-error
        v-if="errors !== undefined && errors.privacy"
        :errors="errors.privacy"/>

    </p>

    <button
      class="submit-button"
      @click="$_send">{{ $t('privacyForm.labelSubmit') }}</button>
  </div>
</template>

<script>
import axios from 'axios'
import FormError from '@/components/FormError'
import { load } from 'recaptcha-v3'

export default {
  name: 'PrivacyForm',
  components: {
    FormError
  },
  data: () => ({
    name: '',
    surname: '',
    email: '',
    note: '',
    checkboxes: {
      sendCopy: false,
      mailChimp: false,
      removeAll: false,
      removeMarketing: false,
      privacy: false
    },
    errors: undefined,
    token: undefined,
    loading: false
  }),
  props: {
    fromSite: {
      type: String,
      required: true
    },
    mailchimp: {
      type: Boolean,
      default: false
    },
    siteData: {
      type: Object,
      required: true
    },
    locale: {
      type: String,
      required: true
    }
  },
  methods: {
    async $_send () {
      this.loading = true
      // get recaptcha token
      const getToken = await this.$_getToken()
      if (!getToken) {
        this.$emit('error', {})
        return
      }
      // check form datas
      const isValid = await this.$_validate()
      if (!isValid) {
        if (this.errors !== undefined) return
        this.$emit('error', {})
        return
      }
      // send mail
      const sendMail = await this.$_sendMail()
      if (!sendMail) {
        this.$emit('error', {})
        return
      }
      this.$emit('send')
    },
    async $_getToken () {
      try {
        const recaptcha = await load('6LexjaEUAAAAAGru6vd8X8jJUnMngd3CaUpC70DF')
        this.token = await recaptcha.execute('homepage')
        if (typeof this.token !== 'undefined') return true
        return false
      } catch (err) {
        console.log('validateRecaptcha', err)
        return false
      }
    },
    async $_validate () {
      try {
        const validation = await axios.post(`https://europe-west1-quamm-gdpr-38d1e.cloudfunctions.net/validation/language/${this.locale}/form/validate`, {
          name: this.name,
          surname: this.surname,
          email: this.email,
          note: this.note,
          fromSite: this.fromSite,
          checkboxes: this.checkboxes
        })
        if (validation.data.status === 'pass') return true
        return false
      } catch (err) {
        if (typeof err.response !== undefined) this.errors = err.response.data
        this.loading = false
        return false
      }
    },
    async $_sendMail () {
      const currentDate = new Date()
      const date = currentDate.getDate()
      const month = currentDate.getMonth()
      const year = currentDate.getFullYear()
      try {
        const sendMail = await axios.post(`https://europe-west1-quamm-gdpr-38d1e.cloudfunctions.net/sendmail/send`, {
          data: {
            name: this.name,
            surname: this.surname,
            email: this.email,
            note: this.note,
            fromSite: this.fromSite,
            checkboxes: this.checkboxes,
            // others
            urlLogo: this.siteData.urlLogo,
            stylesLogo: this.siteData.stylesLogo,
            legalName: this.siteData.legalName,
            address: this.siteData.data,
            telephone: this.siteData.telephone,
            siteEmail: this.siteData.email,
            simpleUrl: this.siteData.simpleUrl,
            url: this.siteData.url,
            date: date + "/" + (month+1) + "/" + year
          },
          context: {
            token: this.token,
            model: 'privacy'
          }
        })
        if (sendMail.data.status === 'pass') return true
        return false
      } catch (err) {
        console.log('validateRecaptcha', err)
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.recaptcha-container {
  margin: 4rem auto;
}

.form-gestione-dati{
  margin: 2rem 0;
}

*, *:after, *:before {
  box-sizing: border-box;
}

.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

.input {
  position: relative;
  z-index: 1;
  display: inline-block;
  margin: .8rem 0;
  width: 100%;
  vertical-align: top;
}
.input__field {
  position: relative;
  display: block;
  float: right;
  padding: 0.8em;
  width: 60%;
  border: none;
  border-radius: 0;
  background: #f0f0f0;
  color: #aaa;
  -webkit-appearance: none;
}
.input__field:focus {
  outline: none;
}
.input__field--juro {
  position: absolute;
  z-index: 100;
  padding: 1.6rem 1rem 0;
  width: 100%;
  background: transparent;
  color: #313131;
  font-size: 23px;
  line-height: 1.2;
}
.input__label {
  display: inline-block;
  float: right;
  padding: 0 1em;
  width: 40%;
  color: #646464;
  font-weight: bold;
  font-size: 70.25%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.input__label-content {
  position: relative;
  display: block;
  padding: 1.6em 0;
  width: 100%;
}
.input__label-content--juro {
  font-size: 23px; line-height: 1;
  color: #646464;
  padding: 1.6rem 1rem;
  -webkit-transform-origin: 0% 50%;
          transform-origin: 0% 50%;
  transition: color 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, color 0.3s;
  transition: transform 0.3s, color 0.3s, -webkit-transform 0.3s;
  text-rendering: geometricPrecision;
}
.input__label--juro {
  padding: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: left;
  border: 1px solid #DBDBDB !important;
}
.input__label--juro::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0px solid transparent;
  transition: border-width 0.3s, border-color 0.3s;
}
.input--juro {
  overflow: hidden;
}

.input__field--juro:focus + .input__label--juro::before,
.input--filled .input__label--juro::before {
  border-width: 8px;
  border-top-width: 2em;
  background: #F8F8F8;
  border: 1px solid #DBDBDB;
}

.input__field--juro:focus + .input__label--juro .input__label-content--juro,
.input--filled .input__label--juro .input__label-content--juro {
  color: #C4C4C4;
  -webkit-transform: translate3d(.3rem, -1em, 0) scale3d(0.6, 0.6, 1) translateZ(1px);
          transform: translate3d(.3rem, -1em, 0) scale3d(0.6, 0.6, 1) translateZ(1px);
}

// CHECKS

.area-checks{
  background-color: #ECECEC;
  border-radius: 12px;
  padding: 1.2rem 2rem; margin: 40px 0;

}

.checks {
    margin: 40px 0;
    text-align: left;
    position: relative;
}

.checks-marginUp{
  margin: 60px 0;
}

input[type="checkbox"]{
  width: 20px;
  opacity: 0;
  position: absolute;
  top: 5px;
}

.text_check {
  margin-left: 60px;
  font-size: 1rem;
  height: 40px;
  display: block;
  font-size: 14px;
}

.label_check .before {
  content: "";
  border: 1px solid #979797;
  display: inline-block;
  width: 40px;
  height: 40px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f3f3f3;
  background-position: center center;
  background-repeat: no-repeat;
}

.area-checks .label_check .before {
  content: "";
  background-color: #F0F0F0;
}

input:checked + .label_check .before {
  background-image: url("data:image/svg+xml,%3Csvg width='16px' height='21px' viewBox='0 0 16 21' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-1920-Copy' transform='translate%28-681.000000, -1354.000000%29' stroke='%235C5C5C' stroke-width='3'%3E%3Cpolyline id='Path-2-Copy' points='683 1363.7342 688.240929 1371.26784 695 1355'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #FFF;
}

.submit-button {
  cursor: pointer;
  font-size: 20px; line-height: 1;
  text-align: center;
  color: #FFF;
  background-color: #616161;
  border: 0; padding: 1.6rem 4.5rem; font-weight: 400;
}

@media screen and (max-width: 600px) {
 .text_check {
    height: auto;
  }
  .errors-list{
    padding-left:0;
  }
  .submit-button {
    width: 100%;
  }
}

.grecaptcha-badge{
  display: none;
}

</style>
